module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fa0038ea1a10da378c83e4f6ebe839ea.png";